module.exports = __webpack_public_path__ + "6686cf75629f94d835de0a09fc42d9e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/CCC_White@2x.png
// module id = 110
// module chunks = 0